// External Libraries
import { Disclaimers, PricePoint, defineMessages } from 'ouisys-component-library';
// Components

import * as RDS from 'ouisys-engine/dist/common-types/RemoteDataState';
import strategy from 'ouisys-engine/dist/flows/strategy';
import { identifyStrategy, StrategyFlowActionMaps } from 'ouisys-engine/dist/reducers/strategy';
import {
  IDENTIFYMSISDNEntryFailure,
  IDENTIFYMSISDNEntrySuccess,
  IIdenyifyFlowByMsisdnSumbitNextData
} from 'ouisys-engine/dist/reducers/strategy/StrategyTypes';
import store from 'ouisys-engine/dist/store';
import { IApplicationState } from 'ouisys-engine/dist/store/reducers';
import { setOnLoadUtilities } from 'ouisys-engine/dist/utilities';
import { getConfig } from 'ouisys-phone-input/dist/common/PhoneInput';
import * as React from 'react';
import { lazy, useEffect, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import Loader from './components/Loader';
import Footer from './components/Footer';
import OperatorSelection from './components/OperatorSelection';
import PhoneNumberEntryStep from './components/PhoneNumberEntryStep';
import SwitchLang from './components/SwitchLang';
import { tracker } from "ouisys-engine/dist/reducers/strategy";

import { legals, Translate, TranslationProvider } from './localization/index';
// Styling files
import './Root.scss';
import './style.scss';
// Utilities here
import searchToObject from './utils/searchToObject';
import PreLander from './components/PreLander';
import PaymentSuccess from './components/PaymentStatus';

import Click2smsFlow from './flows/Click2smsFlow';
import MoFlow from './flows/MoFlow';
import MoRedirFlow from './flows/MoRedirFlow';
import OneClickFlow from './flows/OneClickFlow';
import PinFlow from './flows/PinFlow';
import UssdFlow from './flows/UssdFlow';
import CreditCardFlow from './flows/CreditCardFlow';
import PaymentStatus from './components/PaymentStatus';

const imgBGm = require('./assets/imgs/bg-M.png');
const imgBGfooter = require('./assets/imgs/footer.png');
const imgMovioScene = require('./assets/imgs/movio-scene.png');
const imgPhone = require('./assets/imgs/phone.png');
const imgScroll = require('./assets/imgs/scroll.gif');
const imgStrip = require('./assets/imgs/strip.png');
const iconHelp = require('./assets/imgs/icon-support.png');

const slider01 = require('./assets/imgs/news.jpg');
const slider02 = require('./assets/imgs/lifestyle.jpg');
const slider03 = require('./assets/imgs/sport.jpg');
const slider04 = require('./assets/imgs/entertainment.jpg');
const slider05 = require('./assets/imgs/elearning.jpg');

// Error messages Messages which might come from backend
const defaultMessages = defineMessages({
  InvalidMSISDN: {
    id: 'InvalidMSISDN',
    defaultMessage: 'This mobile number is incorrect, try again'
  },
  AlreadySubscribed: {
    id: 'AlreadySubscribed',
    defaultMessage: 'You are already a subscriber!'
  },
  UnknownError: {
    id: 'UnknownError',
    defaultMessage: 'An unknown error occurred.'
  },
  InvalidPIN: {
    id: 'InvalidPIN',
    defaultMessage: 'Please enter the correct PIN that you received on your phone'
  },
  SessionBlocked: {
    id: 'SessionBlocked',
    defaultMessage: 'Session Blocked!'
  },
  TooEarly: {
    id: 'TooEarly',
    defaultMessage: 'You must first submit a mobile number'
  },
  didnt_receive_pin_yet: {
    id: 'didnt_receive_pin_yet',
    defaultMessage: "Didn't receive PIN yet?"
  }
});

interface HOCProps {

}
const Root = ({
}: HOCProps) => {
  const [locale, setLocale] = useState('en');
  const [operator, setOperator] = useState<string>(null);
  const [msisdn, setMsisdn] = useState<string>(getConfig(process.env.country).commonPrefix);
  const [skipPrelander, setPrelander] = useState<boolean>(false);
  const [paymentStatus, setPaymentStatus] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { currentState } = useSelector((state: IApplicationState) => state.strategy);
  const urlParams = searchToObject();

  const { d_theme, d_locale, d_image } = urlParams as { d_theme: string; d_locale: string; d_image: string };

  const dImage = d_image ? require(`./assets/imgs/${d_image}.jpg`) : '';

  // Show or hide pre-lander
  const checkSkipPrelander = () => {
    const search = searchToObject();
    if (search['skip-prelander']) {
      setPrelander(search['skip-prelander'] === 'true');
    }
  };

   // Show or hide thank you
   const checkPaymentStatus = () => {
    const search = searchToObject();
    if (search['payment-status']) {
      setPaymentStatus(search['payment-status'] === 'true');
    }
  };

  


  useEffect(() => {
    dispatch(identifyStrategy());
    checkSkipPrelander();
    checkPaymentStatus();

    //for zendesk widget
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=e44e1419-abf3-4f96-bfff-b8e6c0df2bc0';
    script.async = true;
    document.head.appendChild(script);
    //zendesk widget end


    // Set locale based on url designer para
    if (d_locale && !!legals[d_locale]) {
      setLocale(d_locale);
    }

    if (typeof window != "undefined") {
      if (/^es\b/.test(window.navigator.language)) {
        setLocale("es")
        tracker.customEvent("Lang-Switcher", "autodetect", "browserLocale", "es")
      }
  
      if (/^fr\b/.test(window.navigator.language)) {
        setLocale("fr")
        tracker.customEvent("Lang-Switcher", "autodetect", "browserLocale", "fr")
      }
  
      if (/^en\b/.test(window.navigator.language)) {
        setLocale("en")
        tracker.customEvent("Lang-Switcher", "autodetect", "browserLocale", "en")
      }
  
    }
    
    setOnLoadUtilities(currentState?.result?.config);

  }, []);

  // const zendeskWidget = () => {
  //   useEffect(() => {
    
  //   }, []);

  const switchLang = (lang: string) => {
    setLocale(lang);
    if (typeof window !== 'undefined') {
      document.getElementsByTagName('html')[0].setAttribute('lang', lang);
    }
  };

  const openEls = document.querySelectorAll("[data-open]");
  const closeEls = document.querySelectorAll("[data-close]");
  const isVisible = "is-visible";

  const [isActive, setIsActive] = useState(false);

  const handleClick = () =>  {
    setIsActive(true)
  };

  const identifyFlowByMsisdnInterface = (
    rds: RDS.RemoteDataState<IDENTIFYMSISDNEntryFailure, IDENTIFYMSISDNEntrySuccess>,
    nextData: IIdenyifyFlowByMsisdnSumbitNextData
  ) => {
    const { nextAction } = nextData;

    return (
      <PhoneNumberEntryStep
        msisdn={msisdn}
        rds={rds}
        onEnd={(msisdn) => {
          setMsisdn(msisdn);
          dispatch(StrategyFlowActionMaps[nextAction](msisdn));
        }}
        locale={locale}
      />
    );
  };

  return (
    <TranslationProvider locale={locale}>
        <div className="guide">
          {/* pre-lander */}
          {
            skipPrelander &&
            <PreLander/>
          }

          {/* top-legals */}
          <div className="topLegalsWrap">
            {/* <TopLegals className="topLegals" locale={locale} legals={legals} /> */}
          </div>

          {/* Using designer url params example */}
          {d_theme == 'light' && <div>light theme</div>}
          {d_theme == 'dark' && <div>light theme</div>}
          {/* Payment Status */}
          {
            paymentStatus &&
            <PaymentStatus  />
          }
          <div className={`creativeArea ${paymentStatus !== null ? "" : "hide"}`} >
            <a href="#footer" className="srollToBottom">
              <img src={iconHelp} />
            </a>
            <header>

              <div className="brand">
                {/* <svg className="logo-bg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 301.355 84.497" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="linear-gradient" x1="0.015" y1="0.5" x2="0.982" y2="0.5" gradientUnits="objectBoundingBox">
                      <stop offset="0" stop-color="#96001d"/>
                      <stop offset="1" stop-color="#cc2b29"/>
                    </linearGradient>
                  </defs>
                  <path id="Path_1" data-name="Path 1" d="M244.645,373.355a19.164,19.164,0,0,0,16.118,8.794h218.9a19.164,19.164,0,0,0,16.118-8.794l25.107-75.7H219.538Z" transform="translate(-219.538 -297.652)" fill="url(#linear-gradient)"/>
                </svg> */}

                <svg className="logo" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 131.3 126.4">
                  <path className="st0" d="M95.3,0.9c9.5,8.8,18.9,17.6,28.4,26.5c0.4-0.7,0.3-1.3,0.3-1.8c0-7.8,0-15.6,0-23.4c0-1.2,0.3-1.7,1.6-1.6
                    c1.5,0.1,3,0.1,4.5,0c0.9,0,1.3,0.3,1.3,1.2c-0.1,1.3,0,2.5,0,3.8c0,12.2,0,24.3,0,36.5c0,0.5,0,1.1,0,2c-1.3-1.2-2.3-2.1-3.3-3
                    c-8.2-7.6-16.3-15.2-24.5-22.8c-0.3-0.3-0.6-0.8-1.1-0.7c-0.6,0.2-0.3,0.9-0.3,1.3c0,7.7,0,15.5,0,23.2c0,1.4-0.3,2-1.8,1.9
                    c-1.4-0.1-2.8-0.1-4.1,0c-0.9,0-1.2-0.3-1.2-1.1c0-0.4-0.1-0.9-0.1-1.3c0-13,0-26.1,0-39.1C95,2,94.8,1.5,95.3,0.9z"/>
                  <path className="st0" d="M131.3,77.3c-1.3,2.1-2.3,3.8-3.4,5.6c-3.2,5.1-6.3,10.3-9.6,15.3c-0.7,1.1-0.1,1.7,0.3,2.4
                    c3.9,6.3,7.9,12.6,11.8,18.8c0.2,0.4,0.4,0.8,0.8,1.5c-2.6,0-5.1,0-7.5,0c-0.6,0-0.9-0.5-1.2-1c-2.9-4.5-5.7-9-8.6-13.5
                    c-1-1.6-1-1.6-2,0c-2.8,4.5-5.7,8.9-8.5,13.4c-0.5,0.8-1.1,1.2-2,1.2c-2.1-0.1-4.3,0-6.7,0c0.7-1.8,1.7-3,2.6-4.4
                    c3.5-5.4,7-10.7,10.6-16.1c0.7-1,0.7-1.6,0-2.7c-4.2-6.4-8.4-12.8-12.6-19.2c-0.2-0.3-0.4-0.7-0.7-1.3c2.7,0,5.1,0,7.6,0
                    c0.6,0,0.8,0.6,1,1c2.9,4.6,5.9,9.1,8.7,13.8c0.8,1.3,1.2,0.9,1.8-0.1c2.9-4.6,5.8-9.1,8.7-13.6c0.3-0.5,0.6-1.1,1.2-1.1
                    C126.1,77.3,128.6,77.3,131.3,77.3z"/>
                  <path className="st0" d="M11,120.7c-3.2,0-6.4,0-9.6,0c-1,0-1.4-0.3-1.3-1.3c0.1-1.5,0.1-3,0-4.5c-0.1-1.3,0.4-1.6,1.6-1.6
                    c5.9,0.1,11.7,0,17.6,0c3.2,0,5.1-1.8,5.1-5c0-3.4-1.8-5.3-5.1-5.3c-5.9,0-11.7,0-17.6,0c-1.2,0-1.7-0.3-1.6-1.6
                    c0.1-1.5,0.1-3,0-4.5c-0.1-1.2,0.3-1.5,1.5-1.5c4.8,0.1,9.5-0.1,14.3,0.1c3.2,0.1,4.9-1.8,5-5.2c0.1-3.6-1.8-5.6-5-5.6
                    c-4.7,0-9.4-0.1-14.1,0c-1.4,0-1.7-0.4-1.6-1.7c0.1-1.5,0-3.1,0-4.6c0-0.7,0.1-1.2,1-1.2c5.7,0.1,11.4-0.4,17.1,0.2
                    c5.7,0.7,9.3,4.8,9.8,10.6c0.2,3.1,0.2,6.2-1.6,9c-0.5,0.7-0.2,1,0.4,1.5c5.8,4.3,6.2,11.8,3,17.1c-2,3.3-5.3,4.8-9.1,5
                    C17.4,120.8,14.2,120.7,11,120.7C11,120.7,11,120.7,11,120.7z"/>
                  <path className="st0" d="M47.7,16c0-4.6,0.1-9.2,0-13.8c0-1.4,0.4-1.7,1.7-1.6c1.3,0.1,2.5,0.1,3.8,0C54.6,0.5,55,1,54.9,2.4
                    c-0.1,8.4,0,16.8,0,25.2c0,1.8,0.1,3.6,0.9,5.3c1.1,2.3,2.8,4,5.4,4.3c4,0.6,7.8,0.3,10.4-3.4c1.3-1.8,1.4-3.9,1.4-6
                    c0-8.3,0-16.6,0-24.9c0-2.4,0-2.4,2.3-2.4c1.2,0,2.4,0.1,3.6,0c1.2-0.1,1.5,0.4,1.5,1.5c0,8.7,0,17.4,0,26.1
                    c-0.1,5.4-1.7,10.1-6.4,13.3c-2,1.3-4.2,2.1-6.5,2.4c-5.7,0.6-11.3,0.4-15.8-4c-2.7-2.7-3.9-6.2-4-9.9C47.6,25.3,47.7,20.7,47.7,16
                    C47.7,16,47.7,16,47.7,16z"/>
                  <path className="st0" d="M13.9,19.1c3.9,0,7.9,0,11.8,0c1.1,0,1.6,0.3,1.5,1.5c-0.1,1.5-0.1,3,0,4.5c0.1,1.1-0.4,1.4-1.4,1.4
                    c-5.4,0-10.7,0-16.1,0c-1.3,0-1.8,0.3-1.8,1.7c0.1,4.8,0,9.5,0.1,14.3c0,1.4-0.4,1.7-1.7,1.7C4.8,44,3.4,44,2,44.1
                    c-1.1,0.1-1.4-0.3-1.4-1.4c0-7.4,0-14.8,0-22.2c0-1,0.3-1.3,1.3-1.3C5.9,19.2,9.9,19.1,13.9,19.1z"/>
                  <path className="st0" d="M15,7.9c-4.3,0-8.6,0-12.9,0c-1.2,0-1.5-0.4-1.5-1.5c0.1-1.5,0.1-3.1,0-4.6c0-0.9,0.3-1.2,1.2-1.2
                    c8.8,0,17.7,0,26.5,0c0.9,0,1.3,0.3,1.2,1.3c-0.1,1.5-0.1,3.1,0,4.6c0.1,1.1-0.3,1.4-1.4,1.4C23.7,7.9,19.4,7.9,15,7.9z"/>
                  <path className="st1" d="M54.7,99.9l0-12.3l-12.4-6.9c0,0-0.1,7.8-0.1,14.7c0,6.7,0.1,22,0.1,22l12.4-6.9L54.7,99.9
                    C54.7,99.9,54.7,99.9,54.7,99.9z"/>
                  <polygon className="st2" points="86.7,91.7 86.7,91.7 86.7,91.6 86.6,91.6 52.9,71.7 42.2,80.7 73.3,99 42.2,117.4 52.9,126.4 
                    86.6,106.5 86.7,106.5 "/>
                  <polygon id="XMLID_376_" className="st3" points="54.7,90.7 54.7,88 42.2,80.7 "/>
                  <polygon id="XMLID_384_" className="st3" points="54.7,107.3 54.7,110.1 42.2,117.4 "/>
                  <path className="st0" d="M65.4,61.8c-19.6,0-39.1,0-58.7,0c-5.3,0-7-0.1-6.7-0.5c0.4-0.5,0.3-1,0-1.5c-0.1-0.3,1.4-0.4,5.3-0.4
                  c40.1,0,80.2,0,120.3,0c4.3,0,5.7,0.1,5.6,0.4c-0.2,0.5-0.3,1,0,1.5c0.3,0.3-1.6,0.4-6.4,0.4C105,61.8,85.2,61.8,65.4,61.8z"/>
                </svg>
              </div>
              <SwitchLang locale={locale} switchLang={switchLang} />
              <a className="btn" href="https://portal.fun-box.net/login" target="_blank" onClick={() => {tracker.advancedInFlow("Flow","Login");}}>
                <Translate id="login" defaultMessage="Login"></Translate>
              </a>
            </header>
            <main>


          
              <section className="sec1">
                <h1>
                  <Translate id="s1-h1" defaultMessage="Get Endless Entertainment, News, Sports and Premium Content"></Translate>
                </h1>
                <p>
                  <Translate id="s1-p" defaultMessage="A Universe of Video Content Awaits You"></Translate>
                </p>
                <button className="btn btn-red open-payment" onClick={() => {handleClick(); tracker.advancedInPreFlow("startTrial-clicked");}} >
                  <Translate id="startTrial" defaultMessage="start trial"></Translate>
                </button>
                <div className="price-point">
                  €1.99 / <Translate id="daysTrial" defaultMessage="3 Days Trial"></Translate><br />
                  €24.99 / <Translate id="monthlySubscription" defaultMessage="Monthly Subscription"></Translate><br />
                  <Translate id="trialTC" defaultMessage="Trial for eligible new members only • Recurring billing • Cancel at any time"></Translate>
                </div>

                <div className="slider-wrap">
                  <img src={slider01} className="slider-img" />
                  <img src={slider02} className="slider-img" />
                  <img src={slider03} className="slider-img" />
                  <img src={slider04} className="slider-img" />
                  <img src={slider05} className="slider-img" />
                </div>
                <img src={imgScroll} className="scroll" />
              </section>
              <section className="sec2">
                <div className="container">
                  <img src={imgPhone} className="phone" />
                  <div className="content">
                    <h1>
                      <Translate id="s2-h1" defaultMessage="Watch Your Favourite Videos on Any Device"></Translate>
                    </h1>
                    <div className="each">
                      {/* <h2 className="text-gr"><Translate id="s2-h2-1" defaultMessage="mobile tv"></Translate></h2> */}
                      <p><Translate id="s2-p-1" defaultMessage="Stay up-to-date with the latest news, events and lifestyle content from around the world."></Translate></p>
                    </div>
                    <div className="each">
                      {/* <h2 className="text-gr"><Translate id="s2-h2-2" defaultMessage="videos-on-demand"></Translate></h2> */}
                      <p><Translate id="s2-p-2" defaultMessage="Watch engaging and informative videos covering top stories, politics, business, sports, lifestyle  and more."></Translate></p>
                    </div>
                  </div>
                </div>
              </section>
              <section className="sec3">
                <h1 className="text-gr">
                  <Translate id="s3-h1" defaultMessage="The Amazement is Just About to Start"></Translate>
                </h1>
                <p><Translate id="s3-p" defaultMessage="Never Miss a Beat - Subscribe to Get Unlimited Timely Videos"></Translate></p>
                <img src={imgMovioScene} className="movio-scene" />
                <div className="features">
                  <div className="each">
                    <h2 className="text-gr">
                      <Translate id="s3-h2-1" defaultMessage="COMPLETELY AD FREE VIDEOS"></Translate>
                    </h2>
                    <p>
                      <Translate id="s3-p-1" defaultMessage="No need to go through the hassle of ads. We provide an amazing experience without ads. Just enjoy watching your favourite videos."></Translate>
                    </p>
                  </div>
                  <div className="each">
                    <h2 className="text-gr">
                      <Translate id="s3-h2-2" defaultMessage="NO COMMITMENT REQUIRED"></Translate>
                    </h2>
                    <p>
                      <Translate id="s3-p-2" defaultMessage="Cancel your subscription anytime, and where. or contact our support team to help you with the service."></Translate>
                    </p>
                  </div>
                  <div className="each">
                    <h2 className="text-gr">
                      <Translate id="s3-h2-3" defaultMessage="ADD TO FAVOURITE LIST"></Translate>
                    </h2>
                    <p>
                      <Translate id="s3-p-3" defaultMessage="Add and customise what you want to watch from our videos, keep track and get weekly updates."></Translate>
                    </p>
                  </div>
                </div>
                <img src={imgStrip} className="strip" />
              </section>
            </main>
            <Footer />
            {/* <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=f83728de-d343-4e5c-a72b-6dce8aebd93d"></script> */}
            <section className={`payment-page ${ isActive ? "is-visible" : ""}` } >
              <div className="outer-wrap">
                <div className="container">
                  <div className="pp-header">
                    <div className="logo-wrap">
                      <svg className="logo" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 131.3 126.4">
                        <path className="st0" d="M95.3,0.9c9.5,8.8,18.9,17.6,28.4,26.5c0.4-0.7,0.3-1.3,0.3-1.8c0-7.8,0-15.6,0-23.4c0-1.2,0.3-1.7,1.6-1.6
                          c1.5,0.1,3,0.1,4.5,0c0.9,0,1.3,0.3,1.3,1.2c-0.1,1.3,0,2.5,0,3.8c0,12.2,0,24.3,0,36.5c0,0.5,0,1.1,0,2c-1.3-1.2-2.3-2.1-3.3-3
                          c-8.2-7.6-16.3-15.2-24.5-22.8c-0.3-0.3-0.6-0.8-1.1-0.7c-0.6,0.2-0.3,0.9-0.3,1.3c0,7.7,0,15.5,0,23.2c0,1.4-0.3,2-1.8,1.9
                          c-1.4-0.1-2.8-0.1-4.1,0c-0.9,0-1.2-0.3-1.2-1.1c0-0.4-0.1-0.9-0.1-1.3c0-13,0-26.1,0-39.1C95,2,94.8,1.5,95.3,0.9z"/>
                        <path className="st0" d="M131.3,77.3c-1.3,2.1-2.3,3.8-3.4,5.6c-3.2,5.1-6.3,10.3-9.6,15.3c-0.7,1.1-0.1,1.7,0.3,2.4
                          c3.9,6.3,7.9,12.6,11.8,18.8c0.2,0.4,0.4,0.8,0.8,1.5c-2.6,0-5.1,0-7.5,0c-0.6,0-0.9-0.5-1.2-1c-2.9-4.5-5.7-9-8.6-13.5
                          c-1-1.6-1-1.6-2,0c-2.8,4.5-5.7,8.9-8.5,13.4c-0.5,0.8-1.1,1.2-2,1.2c-2.1-0.1-4.3,0-6.7,0c0.7-1.8,1.7-3,2.6-4.4
                          c3.5-5.4,7-10.7,10.6-16.1c0.7-1,0.7-1.6,0-2.7c-4.2-6.4-8.4-12.8-12.6-19.2c-0.2-0.3-0.4-0.7-0.7-1.3c2.7,0,5.1,0,7.6,0
                          c0.6,0,0.8,0.6,1,1c2.9,4.6,5.9,9.1,8.7,13.8c0.8,1.3,1.2,0.9,1.8-0.1c2.9-4.6,5.8-9.1,8.7-13.6c0.3-0.5,0.6-1.1,1.2-1.1
                          C126.1,77.3,128.6,77.3,131.3,77.3z"/>
                        <path className="st0" d="M11,120.7c-3.2,0-6.4,0-9.6,0c-1,0-1.4-0.3-1.3-1.3c0.1-1.5,0.1-3,0-4.5c-0.1-1.3,0.4-1.6,1.6-1.6
                          c5.9,0.1,11.7,0,17.6,0c3.2,0,5.1-1.8,5.1-5c0-3.4-1.8-5.3-5.1-5.3c-5.9,0-11.7,0-17.6,0c-1.2,0-1.7-0.3-1.6-1.6
                          c0.1-1.5,0.1-3,0-4.5c-0.1-1.2,0.3-1.5,1.5-1.5c4.8,0.1,9.5-0.1,14.3,0.1c3.2,0.1,4.9-1.8,5-5.2c0.1-3.6-1.8-5.6-5-5.6
                          c-4.7,0-9.4-0.1-14.1,0c-1.4,0-1.7-0.4-1.6-1.7c0.1-1.5,0-3.1,0-4.6c0-0.7,0.1-1.2,1-1.2c5.7,0.1,11.4-0.4,17.1,0.2
                          c5.7,0.7,9.3,4.8,9.8,10.6c0.2,3.1,0.2,6.2-1.6,9c-0.5,0.7-0.2,1,0.4,1.5c5.8,4.3,6.2,11.8,3,17.1c-2,3.3-5.3,4.8-9.1,5
                          C17.4,120.8,14.2,120.7,11,120.7C11,120.7,11,120.7,11,120.7z"/>
                        <path className="st0" d="M47.7,16c0-4.6,0.1-9.2,0-13.8c0-1.4,0.4-1.7,1.7-1.6c1.3,0.1,2.5,0.1,3.8,0C54.6,0.5,55,1,54.9,2.4
                          c-0.1,8.4,0,16.8,0,25.2c0,1.8,0.1,3.6,0.9,5.3c1.1,2.3,2.8,4,5.4,4.3c4,0.6,7.8,0.3,10.4-3.4c1.3-1.8,1.4-3.9,1.4-6
                          c0-8.3,0-16.6,0-24.9c0-2.4,0-2.4,2.3-2.4c1.2,0,2.4,0.1,3.6,0c1.2-0.1,1.5,0.4,1.5,1.5c0,8.7,0,17.4,0,26.1
                          c-0.1,5.4-1.7,10.1-6.4,13.3c-2,1.3-4.2,2.1-6.5,2.4c-5.7,0.6-11.3,0.4-15.8-4c-2.7-2.7-3.9-6.2-4-9.9C47.6,25.3,47.7,20.7,47.7,16
                          C47.7,16,47.7,16,47.7,16z"/>
                        <path className="st0" d="M13.9,19.1c3.9,0,7.9,0,11.8,0c1.1,0,1.6,0.3,1.5,1.5c-0.1,1.5-0.1,3,0,4.5c0.1,1.1-0.4,1.4-1.4,1.4
                          c-5.4,0-10.7,0-16.1,0c-1.3,0-1.8,0.3-1.8,1.7c0.1,4.8,0,9.5,0.1,14.3c0,1.4-0.4,1.7-1.7,1.7C4.8,44,3.4,44,2,44.1
                          c-1.1,0.1-1.4-0.3-1.4-1.4c0-7.4,0-14.8,0-22.2c0-1,0.3-1.3,1.3-1.3C5.9,19.2,9.9,19.1,13.9,19.1z"/>
                        <path className="st0" d="M15,7.9c-4.3,0-8.6,0-12.9,0c-1.2,0-1.5-0.4-1.5-1.5c0.1-1.5,0.1-3.1,0-4.6c0-0.9,0.3-1.2,1.2-1.2
                          c8.8,0,17.7,0,26.5,0c0.9,0,1.3,0.3,1.2,1.3c-0.1,1.5-0.1,3.1,0,4.6c0.1,1.1-0.3,1.4-1.4,1.4C23.7,7.9,19.4,7.9,15,7.9z"/>
                        <path className="st1" d="M54.7,99.9l0-12.3l-12.4-6.9c0,0-0.1,7.8-0.1,14.7c0,6.7,0.1,22,0.1,22l12.4-6.9L54.7,99.9
                          C54.7,99.9,54.7,99.9,54.7,99.9z"/>
                        <polygon className="st2" points="86.7,91.7 86.7,91.7 86.7,91.6 86.6,91.6 52.9,71.7 42.2,80.7 73.3,99 42.2,117.4 52.9,126.4 
                          86.6,106.5 86.7,106.5 "/>
                        <polygon id="XMLID_376_" className="st3" points="54.7,90.7 54.7,88 42.2,80.7 "/>
                        <polygon id="XMLID_384_" className="st3" points="54.7,107.3 54.7,110.1 42.2,117.4 "/>
                        <path className="st0" d="M65.4,61.8c-19.6,0-39.1,0-58.7,0c-5.3,0-7-0.1-6.7-0.5c0.4-0.5,0.3-1,0-1.5c-0.1-0.3,1.4-0.4,5.3-0.4
                        c40.1,0,80.2,0,120.3,0c4.3,0,5.7,0.1,5.6,0.4c-0.2,0.5-0.3,1,0,1.5c0.3,0.3-1.6,0.4-6.4,0.4C105,61.8,85.2,61.8,65.4,61.8z"/>
                      </svg>
                    </div>
                    <button className="pp-close" onClick={() => setIsActive(false) } data-close>
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <path id="Icon_material-close" d="M28.5,9.615,26.385,7.5,18,15.885,9.615,7.5,7.5,9.615,15.885,18,7.5,26.385,9.615,28.5,18,20.115,26.385,28.5,28.5,26.385,20.115,18Z" transform="translate(-7.5 -7.5)"/>
                      </svg>
                    </button>
                  </div>
                  <div className="inner-wrap">
                  <div className="right">
                    <h2><Translate id="registerTitle" defaultMessage="Finish your Registration"></Translate></h2>
                    <p><Translate id="registerIntro" defaultMessage="The subscription starts now for just €1,99/3 days trial. The subscription will be automatically prolonged for €24,99 / monthly after the first period"></Translate></p>
                    {strategy({
                      identifyFlowByOperatorSelect: (data) => <OperatorSelection {...data} setOperator={setOperator} />,
                      identifyFlowByMsisdn: (rds, nextData) => identifyFlowByMsisdnInterface(rds, nextData),
                      pinFlow: (nextData) => (
                        <PinFlow
                          nextData={nextData}
                          locale={locale}
                          msisdn={msisdn}
                          operator={operator}
                          setMsisdn={setMsisdn}
                        />
                      ),
                      moFlow: (nextData) => (
                        <MoFlow nextData={nextData} locale={locale} msisdn={msisdn} operator={operator} setMsisdn={setMsisdn} />
                      ),
                      moRedirFlow: (nextData) => ( 
                        <MoRedirFlow
                          nextData={nextData}
                          locale={locale}
                          msisdn={msisdn}
                          operator={operator}
                          setMsisdn={setMsisdn}
                        />
                      ),
                      oneClickFlow: (nextData) => <OneClickFlow nextData={nextData} locale={locale} operator={operator} />,
                      click2smsFlow: (nextData) => <Click2smsFlow nextData={nextData} locale={locale} operator={operator} />,
                      ussdFlow: (nextData) => (
                        <UssdFlow
                          nextData={nextData}
                          locale={locale}
                          msisdn={msisdn}
                          operator={operator}
                          setMsisdn={setMsisdn}
                        />
                      ),
                      creditCardFlow: (nextData)=>
                      <CreditCardFlow
                          nextData={nextData}
                          locale={locale}
                        />
                      
                    })(currentState)}
                    </div>
                    <div className="left">
                      <div className="each">
                        <h2><Translate id="regTerms-title-1" defaultMessage="Safe and Secure"></Translate></h2>
                        <p><Translate id="regTerms-p-1" defaultMessage="All user data are protected in the service.  Your information is safe and secure as we protect our member’s information by using the best security measures possible. We will not sell or rent your private information to third parties, we value your privacy."></Translate></p>
                      </div>
                      <div className="each">
                        <h2><Translate id="regTerms-title-2" defaultMessage="Why do we need your billing information?"></Translate></h2>
                        <p><Translate id="regTerms-p-2" defaultMessage="Because we are only licensed to distribute our content to certain countries, we ask that you verify your mailing address by providing us with a valid credit card number."></Translate></p>
                      </div>
                      <div className="each">
                        <h2><Translate id="regTerms-title-3" defaultMessage="Sign up today, here’s why:"></Translate></h2>
                        <li><Translate id="regTerms-li-1" defaultMessage="Exclusive content"></Translate></li>
                        <li><Translate id="regTerms-li-2" defaultMessage="Ad-free!"></Translate></li>
                      </div>
                      <div className="each">
                        <h2><Translate id="regTerms-title-4" defaultMessage="Get access now and start streaming"></Translate></h2>
                        <p><Translate id="regTerms-p-3" defaultMessage="We make sure to provide our members with a detailed transaction history so that they know what they are paying for. Credit card information is required to facilitate future purchases only."></Translate></p>
                      </div>
                      <div className="each">
                        <h2><Translate id="regTerms-title-5" defaultMessage="Cancellation Policy"></Translate></h2>
                        <p><Translate id="regTerms-p-5" defaultMessage="You can cancel your membership at any time by contacting our Customer Care Department free of charge."></Translate></p>
                        <p><Translate id="regTerms-p2-5" defaultMessage="The charge for your subscription to FunBox will appear on your credit card statement as"></Translate> www.fun-box.net +33 0805 98 5498</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </section>
          </div>

        </div>
        
    </TranslationProvider>
  );
};

const R = () => (
  <Provider store={store}>
    <Root />
  </Provider>
);

export default R;
function componentDidMount() {
  throw new Error('Function not implemented.');
}

